var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsGraphIntestine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 9.845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.155V3.6A3.6 3.6 0 0 1 3.6 0h7.8A3.6 3.6 0 0 1 15 3.6v5.555h32a7 7 0 0 1 7 7v3.4a3.6 3.6 0 0 1-3.6 3.6H3.6a3.6 3.6 0 0 1-3.6-3.6v-10.4zM54 51v7.555a3.6 3.6 0 0 1-3.6 3.6h-7.8a3.6 3.6 0 0 1-3.6-3.6V51H7a7 7 0 0 1-7-7v-3.4A3.6 3.6 0 0 1 3.6 37h46.8a3.6 3.6 0 0 1 3.6 3.6V51z",
    fill: "#EB8EB7"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F5C6DB",
    y: 23.155,
    width: 54,
    height: 14,
    rx: 3.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphIntestine);
export default __webpack_public_path__ + "static/media/icons_graph_intestine.66cfcfcefe46801a8adae8da97ae83d3.svg";
export { ForwardRef as ReactComponent };